var render, staticRenderFns
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=3485bd1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports